// /**
//  * Testimonial Carousel
//  */
import $ from 'jquery';
import 'owl.carousel/dist/owl.carousel.min.js';

const heroCarousel = {
  initHeroCarousel: () => {
    $('#hero-carousel').owlCarousel({
      smartSpeed: 800,
      direction: 'next',
      slideTransition: 'linear',
      loop: false,
      slideBy: 'page',
      items: 3,
      margin: 12,
      stagePadding: 0,
      nav: true,
      dots: true,
      dotsEach: 1,
      autoWidth: true,
      lazyload: false,
      navText: [
        $('.hero-primary-full-width-block').find('.carousel-control-prev-icon'),
        $('.hero-primary-full-width-block').find('.carousel-control-next-icon'),
      ],
      responsive: {
        0: {
          items: 3,
          slideBy: 1,
          dotsEach: 1,
        },
        500: {
          slideBy: 1,
          items: 3,
          dotsEach: 1,
        },
        575: {
          slideBy: 1,
          items: 3,
          dotsEach: 1,
        },
        600: {
          items: 3,
          slideBy: 1,
          dotsEach: 1,
        },
        960: {
          items: 4,
          slideBy: 1,
          dotsEach: 1,
        },
        1200: {
          items: 4,
          slideBy: 1,
          dotsEach: 1,
        },
        1400: {
          items: 4,
          slideBy: 1,
          dotsEach: 1,
        },
        1600: {
          items: 4,
          slideBy: 1,
          dotsEach: 1,
        },
      },
      onInitialized() {
        $('#hero-carousel').find('.owl-item').attr('aria-current', 'false');
        $('#hero-carousel').find('.owl-item.active').attr('aria-current', 'true');
        // Add aria attribute to dots
        $('#hero-carousel')
          .find('.owl-dot')
          .each(function (index) {
            //Add one to index so it starts from 1
            $(this).attr('aria-label', `slide ${index + 1}`);
          });
        $('#hero-carousel').attr('tabindex', '0');
        // Add aria attributes to buttons
        $('.hero-primary-full-width-block').find('.owl-prev').attr('aria-label', 'previous');
        $('.hero-primary-full-width-block').find('.owl-prev').attr('role', 'button');
        $('.hero-primary-full-width-block').find('.owl-next').attr('aria-label', 'next');
        $('.hero-primary-full-width-block').find('.owl-next').attr('role', 'button');

        // Remove controls if only 1 testimonial
        const nav = $('#hero-carousel').find('.owl-nav');
        const dots = $('#hero-carousel').find('.owl-dots');
        const items = $('#hero-carousel').find('.owl-item');

        if (items.length === 1) {
          nav.addClass('hide-controls');
          dots.addClass('hide-controls');
        }

        // Make entire tile clickable
        items.on('click', (e) => {
          window.location = e.currentTarget.querySelector('a').href;
        });
      },
    });
  },
};

export default heroCarousel;
